import { cva } from '@/styled-system/css';

export const datePickerInputGroupRecipe = cva({
  base: {
    'display': 'flex',
    'boxShadow': {
      base: 'inset 0 0 0 {borderWidths.default} var(--shadow-color)',
    },
    'position': 'relative',
    'transitionProperty': {
      _motionReduce: 'none',
      _motionSafe: 'box-shadow, background-color',
    },
    'transitionDuration': {
      _motionReduce: '0s',
      _motionSafe: '{durations.200}',
    },
    'transitionTimingFunction': '{easings.ease}',
    // need to override the background color of the date input otherwise it covers the input group styles
    '& > .c11n_date-input': {
      backgroundColor: {
        base: 'bg.invisible',
        _hover: 'bg.invisible',
        _active: 'bg.invisible',
        _focusVisible: 'bg.invisible',
      },
    },
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
      },
      false: {},
    },
    error: {
      true: {},
      false: {},
    },
    readOnly: {
      true: {},
      false: {
        'boxShadowColor': {
          base: 'DateInput.border.default',
        },
        '& > .c11n_date-input': {
          borderTopRightRadius: '0',
          borderBottomRightRadius: '0',
        },
      },
    },
    size: {
      sm: {
        borderRadius: 'obj.default',
      },
      md: {
        borderRadius: 'obj.default',
      },
      lg: {
        borderRadius: 'obj.default',
      },
    },
  },
  compoundVariants: [
    {
      disabled: false,
      readOnly: false,
      css: {
        'backgroundColor': {
          base: 'DatePicker.InputGroup.bg.default',
          _hover: 'DatePicker.InputGroup.bg.hover',
          _hasActive: 'bg.neutral',
        },
        'boxShadowColor': {
          base: 'DatePicker.InputGroup.border.default',
        },
        '&:has(:focus-visible), &:has(:focus-visible):hover': {
          backgroundColor: 'bg.neutral',
        },
      },
    },
    {
      disabled: false,
      readOnly: false,
      error: false,
      css: {
        'boxShadowColor': {
          _hover: 'DatePicker.InputGroup.border.hover',
          _hasActive: 'DatePicker.InputGroup.border.active',
        },
        '&:has(:focus-visible)': {
          boxShadowColor: 'DatePicker.InputGroup.border.active',
        },
        '&:has(:focus-visible):hover': {
          boxShadowColor: 'DatePicker.InputGroup.border.hover',
        },
      },
    },
    {
      disabled: false,
      readOnly: false,
      error: true,
      css: {
        'boxShadowColor': {
          base: 'DatePicker.InputGroup.border.error',
          _hover: 'DatePicker.InputGroup.border.errorHover',
          _hasActive: 'DatePicker.InputGroup.border.errorActive',
        },
        '&:has(:focus-visible)': {
          boxShadowColor: 'DatePicker.InputGroup.border.errorActive',
        },
        '&:has(:focus-visible):hover': {
          boxShadowColor: 'DatePicker.InputGroup.border.errorHover',
        },
      },
    },
  ],
});
